enum GuarantorType {
    InNetherlands = 'IN_NETHERLANDS',
    Abroad = 'ABROAD',
    NoGuarantor = 'NO_GUARANTOR'
}

export default GuarantorType
